const sortByField = <T>(
  array: T[],
  field: keyof T,
  descending: boolean = false
): T[] =>
  [...array].sort((a, b) => {
    const aVal = a[field];
    const bVal = b[field];

    // handle undefined/null
    if (aVal == null && bVal == null) return 0;
    if (aVal == null) return descending ? 1 : -1;
    if (bVal == null) return descending ? -1 : 1;

    let comparison: number;

    // handle Dates
    const aDate = aVal instanceof Date ? aVal : new Date(String(aVal));
    const bDate = bVal instanceof Date ? bVal : new Date(String(bVal));
    const isDate =
      !Number.isNaN(aDate.getTime()) &&
      !Number.isNaN(bDate.getTime()) &&
      (aVal instanceof Date ||
        typeof aVal === "string" ||
        typeof bVal === "string");

    if (isDate) {
      comparison = aDate.getTime() - bDate.getTime();
    } else if (typeof aVal === "number" && typeof bVal === "number") {
      comparison = aVal - bVal;
    } else {
      comparison = String(aVal).localeCompare(String(bVal), undefined, {
        sensitivity: "base",
        usage: "sort",
        numeric: false,
        ignorePunctuation: true,
      });
    }

    return descending ? -comparison : comparison;
  });

export default sortByField;
